import React, {useCallback, useContext, useState} from 'react';
import {PostCodeModal} from "../daumPostCode/PostCodeModal";
import {WizardContext} from "../Wizard";
import {SET_DELIVERY_DATA} from "../../WizardConstants";

export function WizardFormDeliveryInput() {
    const { dispatch } = useContext(WizardContext);
    const [zipcode, setZipcode] = useState('');
    const [address1, setAddress1] = useState('');
    const onChange = useCallback(
        (e) => {
          dispatch({ type: SET_DELIVERY_DATA, deliveryName: e.target.name, deliveryValue: e.target.value, isPostCode: false })
        },
        [dispatch],
    );

    return (
        <>
            <div className="row">
                <div className="col-xl-6">
                    {/*begin::Input*/}
                    <div className="form-group">
                        <label><span className="text-danger">* </span>받으실분</label>
                        <input type="text" className="form-control form-control-solid form-control-lg"
                               name="to_name" placeholder="배송받으실 분의 성함을 입력해주세요." onChange={onChange}/>
                        {/*<span className="form-text text-muted">Please enter your Postcode.</span>*/}
                    </div>
                    {/*end::Input*/}
                </div>
                <div className="col-xl-6">
                    {/*begin::Input*/}
                    <div className="form-group">
                        <label><span className="text-danger">* </span>연락처</label>
                        <input type="number" className="form-control form-control-solid form-control-lg"
                               name="phone_number" placeholder="휴대전화번호를-없이 입력해주세요." onChange={onChange}/>
                        {/*<span className="form-text text-muted">Please enter your City.</span>*/}
                    </div>
                    {/*end::Input*/}
                </div>
            </div>
            {/*end::Input*/}
            <div className="row">
                <div className="col-xl-6">
                    {/*begin::Input*/}
                    <div className="form-group">
                        <label><span className="text-danger">* </span>우편번호</label>
                        <input type="text" className="form-control form-control-solid form-control-lg"
                               name="zipcode" placeholder="우편번호" defaultValue={zipcode} readOnly/>
                        {/*<span className="form-text text-muted">Please enter your Postcode.</span>*/}
                    </div>
                    {/*end::Input*/}
                </div>
                <div className="col-xl-6">
                    <div className="form-group mt-7 ">
                        <label> </label>
                        <PostCodeModal handleZipcode={setZipcode} handleAddress1={setAddress1}/>
                    </div>
                </div>
            </div>
            {/*begin::Input*/}
            <div className="form-group">
                <label><span className="text-danger">* </span>주소</label>
                <input type="text" className="form-control form-control-solid form-control-lg" name="address1"
                       placeholder="주소" defaultValue={address1} readOnly/>
                {/*<span className="form-text text-muted">Please enter your Address.</span>*/}
            </div>
            {/*end::Input*/}
            {/*begin::Input*/}
            <div className="form-group">
                <label><span className="text-danger">* </span>상세주소</label>
                <input type="text" className="form-control form-control-solid form-control-lg" name="address2"
                       placeholder="상세주소" onChange={onChange}/>
                {/*<span className="form-text text-muted">Please enter your Address.</span>*/}
            </div>
        </>

    );
}
